<template>
  <div>
    <div class="d-flex justify-content ml-2 align-items-center my-2">
      <button
        class="btn btn-sm rounded-circle p-25 cursor-pointer"
        :class="isDark ? 'btn-danger' : 'btn-primary'"
        @click="goBack()"
      >
        <i class="feather icon-arrow-left arrow-icon"></i>
      </button>
      <div
        class="ml-1 text-capitalize text-dark cursor-pointer goback-text"
        @click="goBack()"
      >
        Regresar
      </div>
    </div>

    <b-card class="mx-2 my-1 p-2" no-body>
        <h5>{{ site.name }}</h5>
        <b-row class="mx-0 p-2" align-h="center">
            <b-col sm="12" md="6" lg="3" xl="3">
                <h5>{{ $t("pacom.devices") }}</h5>
                <b-list-group>
                    <b-list-group-item
                        v-for="device in site.devices"
                        :key="device.id"
                        @click="selectDevice(device)"
                        button
                    >
                        <div class="d-flex justify-content-between align-items-center">
                            <b>{{ device.name }}</b>
                            <b-badge variant="primary">
                                {{ device.schema_type.schema_actions.length }} {{ $t("pacom.actions") }}
                            </b-badge>
                        </div>
                    </b-list-group-item>
                </b-list-group>
            </b-col>
            <b-col sm="12" md="6" lg="3" xl="3">
                <h5>{{ $t("pacom.actions") }} {{ deviceSelected.name }}</h5>
                <div v-if="deviceSelected.id">
                    <b-list-group>
                        <b-list-group-item
                            v-for="action in deviceSelected.schema_type.schema_actions"
                            :key="action.id"
                        >
                            <div class="d-flex justify-content-between align-items-center">
                                {{ action.display_name }}
                                <b-button
                                    class="p-0"
                                    size="sm"
                                    variant="white"
                                    :disabled="loading"
                                    @click="executeAction(action, deviceSelected)"
                                >
                                    <b-spinner v-if="action.loading" small ></b-spinner>
                                    <feather-icon
                                        v-else
                                        icon="PlayIcon"
                                        size="15"
                                        color="green"
                                    />
                                </b-button>
                            </div>
                        </b-list-group-item>
                    </b-list-group>
                </div>
            </b-col>
        </b-row>
    </b-card>
  </div>
</template>

<script>
import { computed, ref, onMounted } from "@vue/composition-api";
import store from "@/store";
import router from '@/router';

let siteId = null;

export default {
  mounted() {
    let { id } = this.$route.params;

    siteId = id;
  },
  setup(_, context) {
    //HOOKS
    onMounted(async () => {
        let { id } = router.currentRoute.params;

        await fecthSite(id);
    });

    //DATA
    const deviceSelected = ref({});

    const site = ref({});

    const lastVersion = ref({});

    const loading = ref(false);

    //COMPUTED
    const isDark = computed(() => store.state.appConfig.layout.skin === "dark");

    //METHODS
    const fecthSite = async (siteId) => {
      await store.dispatch('pacom_sites/show', siteId)
        .then(async (response) => {
          let { data } = response;

          site.value = data;
          site.value.devices = data.devices.filter(device => device.schema_type.schema_actions.length)

          await getLastVersion(data.id)
        })
        .catch((error) => {
          console.log('error', error);
        })
    }

    const getLastVersion = async (id_pacom_site) => {
        await store.dispatch('pacom_sites/lastVersion', id_pacom_site)
        .then(response => {
          let { data } = response;

          lastVersion.value = data;
        })
        .catch((error) => {
          console.log('error', error);
        });
    }

    const goBack = () => {
      const basePath = context.root.$route.path.split("/")[1];
      context.root.$router.push(`/${basePath}`);
    };

    const selectDevice = (device) => {
        deviceSelected.value = device;

        deviceSelected.value.schema_type.schema_actions.forEach(action => {
            action.loading = false;
        });
    }

    const executeAction = async (action, device) => {
        loading.value  = true;
        action.loading = true;

        await store.dispatch('pacom_actions/add', {
            id_pacom_master_account: device.id_pacom_master_account,
            id_pacom_schema_action: action.id,
            id_pacom_device: device.id,
            objectId: device.device_id,
            actionId: action.schema_action_id,
            scope: site.value.scope
        })
        .then(async (response) => {
            await getEvents();
        })
        .catch((error) => {
          console.log('error', error);
        })

        loading.value  = false;
        action.loading = false;
    }

    const getEvents = async () => {
        await store.dispatch('pacom_sites/getEvents', {
          id: site.value.id,
          lastVersion: lastVersion.value
        })
        .then(async (response) => {
          let { data } = response;

          if (!data.length) {
            await getEvents();
          } else {
            await getLastVersion(site.value.id);
            await createLog(data);
          }
        })
        .catch((error) => {
          console.log('error', error);
        });
    }

    const createLog = async (events) => {
      await store.dispatch('pacom_logs/add', {
          events: events,
        })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log('error', error);
        });
    }

    return {
      goBack,
      isDark,
      selectDevice,
      executeAction,

      deviceSelected,
      site,
      loading
    }
  },
};
</script>
